module.exports = __webpack_public_path__ + "static/media/develope_tab_img.46d8a7f3.jpg";